import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';

export const useUpdateWorkspaceSettingMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (res: recallApi.UpdateWorkspaceSettingResponse) => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
}) => {
  return useMutation({
    mutationFn: async ({
      workspace_id,
      setting_name,
      setting_value_bool,
      setting_value_char,
      override_members_change,
    }: {
      workspace_id: string;
      setting_name: string;
      setting_value_bool?: string;
      setting_value_char?: string;
      override_members_change?: boolean;
    }) => {
      const body = {
        workspace_id,
        setting_name,
        ...(setting_value_bool !== undefined && { setting_value_bool }),
        ...(setting_value_char !== undefined && { setting_value_char }),
        ...(override_members_change !== undefined && {
          override_members_change,
        }),
      };

      const response = await recallApi.updateWorkspaceSetting({
        body,
        throwOnError: true,
      });

      return response.data;
    },
    onSuccess,
    onError,
  });
};
